var _templateObject;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { styled } from '@creditas-ui/system';
import { ifProp, selectTheme } from '@creditas-ui/utilities';
import { Box } from '@creditas-ui/layout';
var InputRadio = styled(Box.withComponent('input', process.env.NODE_ENV === "production" ? {
  target: "e77nwsj0"
} : {
  target: "e77nwsj0",
  label: "InputRadio"
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  appearance: none;\n  position: relative;\n  z-index: 1;\n  margin: 0;\n  flex-shrink: 0;\n  cursor: ", ";\n  width: ", ";\n  height: ", ";\n  opacity: ", ";\n  border-radius: ", ";\n  border-style: solid;\n  border-width: ", ";\n  border-color: ", ";\n  background-color: ", ";\n\n  &:focus {\n    outline: none;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: -5px;\n      left: -5px;\n      width: ", ";\n      height: ", ";\n      opacity: ", ";\n      transform: scale(1);\n      background-color: ", ";\n      border-radius: ", ";\n      animation: ripple ", " linear;\n      overflow: hidden;\n    }\n  }\n\n  @keyframes ripple {\n    from {\n      transform: scale(0);\n    }\n\n    to {\n      transform: scale(1.5);\n    }\n  }\n"])), ifProp('disabled', 'not-allowed', 'pointer'), selectTheme('radio.shape.width'), selectTheme('radio.shape.height'), ifProp('disabled', selectTheme('radio.shape.disabled.opacity')), selectTheme('radio.shape.radius'), selectTheme('radio.shape.borderWidth'), ifProp({
  disabled: true,
  checked: false
}, selectTheme('radio.shape.disabled.borderColor'), ifProp('checked', selectTheme('radio.shape.active.borderColor'), selectTheme('radio.shape.borderColor'))), ifProp('checked', selectTheme('radio.shape.active.background'), selectTheme('radio.shape.background')), selectTheme('radio.shape.outter.width'), selectTheme('radio.shape.outter.height'), ifProp('checked', selectTheme('radio.shape.ripple.active.opacity'), selectTheme('radio.shape.ripple.opacity')), selectTheme('radio.shape.ripple.background'), selectTheme('radio.shape.radius'), selectTheme('radio.shape.ripple.transition'));
InputRadio.defaultProps = {
  type: 'radio'
};
export { InputRadio };